var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:[`color-${_vm.color}`, `size-${_vm.size.toLowerCase()}`],attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('icon-btn-clicked')}}},[_c('v-icon',[_vm._v(_vm._s(`${_vm.icon}`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }